<script>
  import { format } from 'svelte-i18n';
  import { Button, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { reassignField } from '@client/stores/bizcard';

  import { generateUUID } from '@common/utils/strings';

  /**
   * The field to be displayed.
   * @type {import('@client/stores/types').AssignedField}
   */
  export let field;

  let id = `available-${generateUUID()}`;

  const addField = () => {
    reassignField({ ...field, field: undefined, hidden: false });
  };
</script>

<div class="d-flex align-items-center border-bottom py-2">
  <Button
    aria-label={$format('label.FIELD_ADD')}
    color="link"
    size="sm"
    class="p-0 me-2 text-success"
    {id}
    on:click={addField}
  >
    <Icon name="plus" />
  </Button>
  <Tooltip target={id}>{$format('label.TOOLTIP.FIELD_ADD')}</Tooltip>
  <small>{field.name}</small>
</div>
